export const updateLog = [
  {
    version: "4.0.0",
    date: "4/7/2022",
    cover: true,
    body: [
      "- New Video Converter preset: [Matrix]",
      "- Added language support! Avaliable in English US, Chinese simplified and traditional. More coming in the future.",
      "- Bug fixes and UI improvements."
    ],
  },
  {
    version: "3.8.0",
    date: "4/7/2022",
    cover: false,
    body: [
      "- Updated function to switch camera. New UI for switching camera.",
    ],
  },
  {
    version: "3.7.3",
    date: "4/5/2022",
    cover: false,
    body: [
      "- Added service worker to the App, better offline support.",
      "- Improved UI designs.",
      "- Fixed a bug on iOS standalone mode icon issue.",
      "- Bug fixes and performance improvements.",
    ],
  },
  {
    version: "3.7.2",
    date: "4/3/2022",
    cover: true,
    body: [
      "- Added preset sections to video converter, now you can easily switch between presets without going through any settings. You can also see the preset settings by clicking on the info button.",
      "- Added the ability to switch camera facing mode. (Only if multiple cameras are available)",
      "- Added image frame to Spike Pie Generator, now every image looks more elegant and artistic!",
      "- Redesigned core components to be more modular and easier to use.",
      "- Updated dark mode UI secondary background to increase contrast between list items.",
      "- Bug fixes and performance improvements.",
    ],
  },
  {
    version: "3.4.0",
    date: "3/30/2022",
    cover: false,
    body: [
      "- Added the option to clear all settings from device.",
      "- Fixed video converter download selected images still donwload all images.",
      "- Fixed color picker causes app freezes and updated UI.",
      "- Fixed different screen density have the same DPI count.",
      "- Fixed video converter doesn't work on mobile devices.",
      "- Fixed video converter images with no warning prompt before deleting",
    ],
  },
  {
    version: "3.3.0",
    date: "3/29/2022",
    cover: true,
    body: [
      "- Added Snapshot gallery to video converter, now you can caputre and download your favorite snapshots!",
      "- Standarlized some backend code.",
      "- Huge performance improvements.",
      "- Fixed many known issues.",
    ],
  },
  {
    version: "3.0.0",
    date: "3/28/2022",
    cover: true,
    body: [
      "- Introducing... [Video Converter] 🎉",
      "- Turning live camera into fun emojis or circles of all colors. More features coming soon...",
      "- Fixed many bugs.",
    ],
  },
  {
    version: "2.2.0",
    date: "3/24/2022",
    cover: true,
    body: [
      "- Added update logs.",
      "- Added masorny layout to generated images, more consistant layout.",
      "- Added a new color mode in spike pie customize settings: [Color Palette], with this you can see all available colors to generate at once. ",
      "- Fixed a bug where spike pie image inforamtion contains preivous image info.",
      "- Fixed UI layout for larger screens.",
    ],
  },
  {
    version: "2.1.0",
    date: "3/23/2022",
    cover: false,
    body: [
      "- Added new video and thumbnail for spike pie generator.",
      "- Fixed some bugs and aware of a few performance issues, fixes coming soon.",
    ],
  },
  {
    version: "2.0.0",
    date: "3/22/2022",
    cover: true,
    body: [
      "- V2 inital release. New project - Spike Pie generator, check it out now!",
    ],
  },
];
